<div class="tags-display" [class.compact]="isCompact()">
  @for (tag of visibleTags(); track tag) {
  <!-- A clickable tag is a filter door — reachable and Enter-able; a plain tag is a label. -->
  <p-chip class="focus-ring"
          [attr.role]="isClickable() ? 'button' : null"
          [attr.tabindex]="isClickable() ? 0 : null"
          (click)="onTagClick(tag)"
          (keydown.enter)="isClickable() && onTagClick(tag)"
          [styleClass]="'tag-chip ' + (isClickable() ? 'clickable' : '')"
          [pTooltip]="tag">
    {{ tag }}
  </p-chip>
  }

  @if (hasMore() && !expanded()) {
  <button class="show-more-btn"
          (click)="toggleExpanded()">
    +{{ remainingCount() }} {{ 'tags.more' | translate }}
  </button>
  }

  @if (hasMore() && expanded()) {
  <button class="show-less-btn"
          (click)="toggleExpanded()">
    {{ 'tags.showLess' | translate }}
  </button>
  }
</div>
